import {
  HOME_GET_CONFIG_BEGIN,
  HOME_GET_CONFIG_SUCCESS,
  HOME_GET_CONFIG_FAILURE,
  HOME_GET_CONFIG_DISMISS_ERROR,
} from './constants';

//HELPERS
import { API } from '../../../helper/api';
import ReduxHelper from '../../../helper/redux';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getConfig(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_GET_CONFIG_BEGIN,
    });

    return API.get('webconfig', args).then(
      (res) => {
        if(res.status === 200)
          dispatch({
            type: HOME_GET_CONFIG_SUCCESS,
            data: res.data,
          });
        else return false;
      }).catch( 
        (err) => {
          dispatch({
            type: HOME_GET_CONFIG_FAILURE,
            data: { error: err },
          });
        },
      );
    }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetBookingssError() {
  return {
    type: HOME_GET_CONFIG_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_GET_CONFIG_BEGIN:
      return ReduxHelper.begin(state, getConfig.name);

    case HOME_GET_CONFIG_SUCCESS:
      return {
        ...ReduxHelper.success(state, getConfig.name),
        config: action.data
      }

    case HOME_GET_CONFIG_FAILURE:
      return ReduxHelper.error(state, getConfig.name, action.data.error);

    case HOME_GET_CONFIG_DISMISS_ERROR:
      return ReduxHelper.dismiss(state, getConfig.name);
  
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/getConfig.js